import React from 'react';
import PropTypes from 'prop-types';

export default function IndeterminateCheckbox({ isIndeterminate = false, ...otherProps }) {
  const setCheckboxRef = (checkbox) => {
    if (checkbox) {
      checkbox.indeterminate = isIndeterminate;
    }
  };

  return (
    <input
      type="checkbox"
      ref={setCheckboxRef}
      {...otherProps}
    />
  );
}

IndeterminateCheckbox.propTypes = {
  isIndeterminate: PropTypes.bool,
};
